import React, { useState } from "react";
import styles from "./index.module.scss";
import Toggle from "../../UI/Toggle";

const PlanSwitcher = ({ onChange, value = false }) => {
  const [checked, setChecked] = useState(value);
  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <span>Monthly</span>
        <Toggle
          value={value}
          onChange={(e) => {
            setChecked(e.target.checked);
            onChange(e.target.checked);
          }}
        />
        <span>Annually</span>
      </div>
      <p>Save 15% with annual plans</p>
    </div>
  );
};

export default PlanSwitcher;
